import httpUtil from "@/utils/httpUtil";

export const selectcategoryList = params => httpUtil.get("/category", params);
export const selectAllCategory = params => httpUtil.get("/category/noPage", params);
export const addOrUpdateCategory = params => httpUtil.post("/category", params);
export const delCategory = params => httpUtil.post("/category/delete",params);


